export const BracketTypeEnum = {
  None: 0,
  Dollars: 1,
  Weight: 2,
  Quantity: 3
}


// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ItemMaintenanceEnum.js